const module = { name: 'desktop/global/getZip', exports: {} }; const exports = module.exports;



import { default as $ } from 'swug-fdRequire-call:jQuery';



import { Fandango_geolocator as geolocator } from 'require-global';



import { fd_location as fd_location_getLocation } from 'require-global';

const { getLocation } = fd_location_getLocation;


import { fd_url_manager as links } from 'require-core';



import { default as shared_utils_urlHelpers_generateTspLink } from 'swug-fdRequire-call:shared/utils/urlHelpers';

const { generateTspLink } = shared_utils_urlHelpers_generateTspLink;


const RegExes = {
    SPACES: /\s+/g,
    CITY_ST: /^(.*),\s*(\w+)$/,
}
function getLocationSlug() {
    const location = getLocation();
    if (!location) {
        return null;
    }
    const { postalCode, city, region, country, name } = location;
    if (country && country !== 'US') {
        if (postalCode) {
            return `${postalCode.replace(RegExes.SPACES, '-')}_${country}`.toLowerCase();
        }
        if (city && region) {
            return `${city.replace(RegExes.SPACES, '-')}_${region.replace(RegExes.SPACES, '-')}_${country}`.toLowerCase();
        }
    }
    if (postalCode) {
        return postalCode;
    }
    else if (city && region) {
        return `${city.replace(RegExes.SPACES, '-')}_${region}`.toLowerCase();
    }
    else if (name && RegExes.CITY_ST.test(name)) {
        const [, c, r] = name.match(RegExes.CITY_ST);
        return `${c.replace(RegExes.SPACES, '-')}_${r}`.toLowerCase();
    }
    return null;
}
function init(selector) {
    const slug = getLocationSlug();
    if (slug) {
        return $(selector).prop('href', generateTspLink(slug));
    }
    geolocator.getZip((err, zip) => {
        $(selector).prop('href', zip ? generateTspLink(zip) : links.tspMovieTimes());
    });
}
module.exports = {
    init
};
export default module.exports;